<template>
  <sticky-header-layout>
    <!-- Header -->
    <template #header>
      <list-page-header>
        <div slot="right">
          <el-button
            :disabled="isSaving"
            size="mini"
            type="warning"
            icon="el-icon-close"
            @click="handleCancel"
          >{{ $t('button.cancel') }}</el-button>
          <el-button
            :disabled="isLoading"
            :loading="isSaving"
            size="mini"
            type="danger"
            icon="el-icon-upload2"
            @click="handleSave"
          >{{ $t('button.save') }}</el-button>
        </div>
      </list-page-header>
    </template>
    <!-- Header -->

    <div v-loading="isLoading">
      <!-- <generic-form
        ref="form"
        :attributes="formAttributes"
        :form="form"
        :form-template="brandFormTemplate"
        class="pt-3"
      > -->
      <el-form
        ref="form"
        :disabled="isSaving"
        :model="form"
        :rules="brandFromRule"
        class="round-border-form"
        label-position="top"
        label-width="200"
      >
        <el-form-item
          label="Name"
          prop="name"
        >
          <el-input
            v-model="form.name"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="Display Name"
          prop="displayname">
          <el-input
            v-model="form.displayname"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="Slug"
          prop="slug">
          <el-input
            v-model="form.slug"
            clearable
          />
        </el-form-item>
        <el-form-item
          label="Image Url"
          prop="image"
        >
          <el-input
            v-model.trim="form.image"
            clearable
          />
        </el-form-item>
        <div class="form-group">
          <el-form-item
            label="Bio"
            prop="bio"
          >
            <el-input 
              v-model="form.bio"
              clearable
            />
          </el-form-item>
        </div>
        <div class="form-group">
          <el-form-item
            label="Available Country(s)"
            prop="available_countries"
          >
          <country-checkbox-group
            v-model="form.available_countries"
            :disabled="disabled"
          />
          </el-form-item>
        </div>

        <div v-if="!isEditMode">
          <h4 class="title">Create Brand</h4>
          <div class="form-group">
            <el-form-item
              label="Memeber Name"
              prop="member.name"
            >
              <el-input
                v-model="form.member.name"
                required
                placeholder="e.g. John Doe"
                style="width: 50%;"
              />
            </el-form-item>
            <el-form-item
              class="mt-3"
              label="Username"
              prop="member.username"
            >
              <el-input
                v-model.trim="form.member.username"
                clearable
              />
            </el-form-item>
            <el-form-item
              class="mt-3"
              label="Profile Image"
              prop="brand_profile_image"
            >
              <el-upload
                id="profile-image-uploader"
                ref="uploader"
                v-model="brand_profile_image"
                :limit="1"
                :disabled="isUploading"
                :http-request="handleUpload"
                :before-upload="handleBeforeUpload"
                :on-exceed="handleUploaderlimitExceed"
                :on-error="uploadfailed"
                :on-success="uploadSuccessful"
                :file-list="profile_image"
                list-type="picture"
                class="profile-image-uploader"
                name="brand image uploader"
                multiple
                drag
                accept=".png, .jpg"
                action="noneed"
              >
                <i class="el-icon-upload" />
                <div class="el-upload__text">Drop Image here or <em>click to upload</em></div>
              </el-upload>
              <div
                v-if="brand_profile_image != ''"
                class="font-size-14"
              >
                Your Profile Image will be <strong>{{ brand_profile_image.name }}</strong>
                <el-button
                  class="cancel-button ml-2 pa-1"
                  size="mini"
                  type="danger"
                  icon="el-icon-close"
                  circle
                  @click="handleDeleteProfileImage"
                />
              </div>
            </el-form-item>
          </div>
        </div>
        <div v-else>
          <h4 class="title">Edit Member</h4>
          <div class="form-group">
            <el-form-item
              label="Memeber Name"
              prop="member.name"
            >
              <el-input
                v-model="form.member.name"
                required
                placeholder="e.g. John Doe"
                style="width: 50%;"
              />
            </el-form-item>
            <el-form-item
              class="mt-3"
              label="Username"
              prop="member.username"
            >
              <el-input
                v-model.trim="form.member.username"
                clearable
              />
            </el-form-item>
            <el-form-item
              label="Profile Image"
              prop="brand_profile_image"
            >
              <el-upload
                v-loading="isUploading"
                ref="uploader"
                v-model="brand_profile_image"
                :limit="1"
                :disabled="isUploading"
                :http-request="handleUpload"
                :before-upload="handleBeforeUpload"
                :on-exceed="handleUploaderlimitExceed"
                :on-error="uploadfailed"
                :on-success="uploadSuccessful"
                :show-file-list="true"
                drag
                accept=".png, .jpg"
                action="noneed"
              >
                <i class="el-icon-upload" />
                <div class="el-upload__text">Drop Image here or <em>click to upload</em></div>
              </el-upload>
            </el-form-item>
          </div>
          <div
            v-if="brand_profile_image != ''"
            class="font-size-14"
          >
            Your Profile Image will be <strong>{{ brand_profile_image.name }}</strong>
            <el-button
              class="cancel-button ml-2 pa-1"
              size="mini"
              type="danger"
              icon="el-icon-close"
              circle
              @click="handleDeleteProfileImage"
            />
          </div>
        </div>
      </el-form>
      <!-- </generic-form> -->
    </div>
  </sticky-header-layout>
</template>

<script>
import { createComponent, computed, reactive, ref, watch, onBeforeMount } from '@vue/composition-api'
import { checkImageURL } from '../../utils/validate'

import GenericForm from '@/components/form/Form.vue'
import ListPageHeader from '@/views/layout/components/ListPageHeader.vue'
import FieldsetLocalizedInput from '@/components/form/FieldsetLocalizedInput.vue'
import CountryCheckboxGroup from '@/components/form/CountryCheckboxGroup.vue'

import BrandsService from '../../api/brands'
import { brandFormTemplate } from '../../const/brand'
import { slugify } from '../../utils/helper'
import { i18n } from '@/lang'

const BrandDetail = createComponent({
  name: 'BrandDetail',
  components: {
    GenericForm,
    ListPageHeader,
    FieldsetLocalizedInput,
    CountryCheckboxGroup,
  },
  props: {
    id: {
      type: [String, Number],
      default: undefined,
    },
  },
  computed: {
    isEditMode() {
      return !!this.id
    },
  },
  setup({ id }, { root, refs }) {
    const { $router } = root

    let isLoading = ref(false)
    let isSaving = ref(false)
    let isEdited = ref(false)
    let brand_profile_image = ref('')
    let isUploading = ref(false)
    let brand_name = reactive({ required: true, message: 'This field is required.', trigger: 'blur' })

    const form = reactive({
      id: '',
      name: '',
      member: {
        name: '',
        username: '',
      },
      displayname: '',
      slug: '',
      bio: null,
      image: null,
      available_countries: {
        ca: 1,
        us: 1,
        uk: 1,
        sg: 1,
        hk: 1,
        my: 1,
        ph: 1,
        in: 1,
        th: 1,
        au: 1,
        tw: 1,
      },
    })

    const brandFromRule = reactive({
      name: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      displayname: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      slug: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      // member_name: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
      // username: [{ required: true, message: i18n.t('error.thisFieldIsRequired'), trigger: 'blur' }],
    })

    // update slug automatically
    watch(() => form.name, (currName, prevName) => {
      const shouldAutoFillInSlug = slugify(prevName) === form.slug && !id
      if (shouldAutoFillInSlug) {
        form.slug = slugify(currName)
      }
    })

    const formAttributes = computed(() => ({
      disabled: isSaving.value,
      labelWidth: '140px',
    }))

    const goToListPage = () => {
      $router.push({ path: '/brand/list' })
    }

    const handleSaveSuccess = () => {
      isSaving.value = false
      isEdited.value = false
      goToListPage()
    }
    const handleSaveFail = (error) => {
      isSaving.value = false
      root.$alert(`Error: ${error}`, root.$t('error.somethingWentWrong'), {
        type: 'error',
        confirmButtonText: root.$t('button.ok'),
      })
    }

    const getDetail = async (brandId) => {
      isLoading.value = true
      try {
        const { data } = await BrandsService.getDetail(brandId)
        Object.keys(data).forEach((key) => {
          form[key] = data[key]
        })
      } catch (error) {
        this.$alert(this.$t('error.categoryNotFound'), this.$t('button.error'), {
          confirmButtonText: this.$t('button.ok'),
          type: 'error',
        }).then(() => {
          this.goToList()
        })
      } finally {
        isLoading.value = false
      }
    }

    onBeforeMount(() => {
      if (id) {
        getDetail(id)
      }
    })

    const saveBrand = async (brandForm) => {
      isSaving.value = true
      try {
        if (id) {
          await BrandsService.update(brandForm, id, brand_profile_image)
        } else {
          await BrandsService.create(brandForm, brand_profile_image)
        }
        handleSaveSuccess()
      } catch (error) {
        handleSaveFail(error)
      }
    }

    const handleCancel = () => goToListPage()
    const handleSave = () => {
      refs.form.validate().then(() => {
        saveBrand(form)
      }).catch((error) => {
        console.error(error);
        this.$alert(this.$t('error.pleaseFillInAndCheckErrors'), this.$t('common.oops'), {
          confirmButtonText: this.$t('button.ok'),
        });
      })
    }

    const handleUpload = async (uploadAction) => {
      isUploading = true
      try {
        brand_profile_image.value = uploadAction.file
        uploadAction.onSuccess()
      } catch (e) {
        uploadAction.onError(e)
      }
    }

    const handleBeforeUpload = (file) => {
      if (!file.name.includes('.png') && !file.name.includes('.jpg') && !file.name.includes('.jpeg')) {
        this.$alert(
          'Please double check you are uploading a .png, .jpg, or .jpeg file',
          'Incorrect File Type', {
            type: 'error',
            confirmButtonText: 'OK',
          },
        )
        return false
      }
      return true
    }

    const handleUploaderlimitExceed = () => {
      this.$alert(
        'Sorry, please upload one file at a time!',
        'Too Many Files', {
          type: 'error',
          confirmButtonText: 'OK',
        },
      )
    }
    const uploadfailed = (err) => {
      console.log(err)
      alert(
        'Sorry, please upload one file at a time!',
        'Too Many Files', {
          type: 'error',
          confirmButtonText: 'OK',
        },
      )
    }

    const uploadSuccessful = () => {
      refs.uploader.clearFiles()
      isUploading = false
    }

    const handleDeleteProfileImage = () => {
      brand_profile_image = ''
    }

    const prevent = () => {}

    return {
      form,
      formAttributes,
      brandFormTemplate: brandFormTemplate(!!id),

      isLoading,
      isSaving,

      handleCancel,
      handleSave,
      brand_profile_image,
      isUploading,
      handleUpload,
      handleBeforeUpload,
      handleUploaderlimitExceed,
      uploadfailed,
      uploadSuccessful,
      handleDeleteProfileImage,

      brand_name,
      prevent,
      checkImageURL: checkImageURL(),
      brandFromRule,
    }
  },
})

export default BrandDetail
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/form.scss";
@import "~@/assets/styles/table.scss";

.text-only {
  ::v-deep {
    .el-form-item__content {
      margin-top: 4px;
    }
  }
}
</style>
